import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import itIT from 'antd/locale/it_IT';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { AuthProvider } from './contexts/AuthContext';
import { TenantProvider } from './contexts/TenantContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import Companies from './pages/Companies';
import Workers from './pages/Workers';
import Vehicles from './pages/Vehicles';
import Equipments from './pages/Equipments';
import Chemicals from './pages/Chemicals';
import CalendarPage from './pages/CalendarPage';
import Settings from './pages/Settings';
import DocumentTypes from './pages/DocumentTypes';
import Users from './pages/Users';
import ChangePassword from './pages/ChangePassword';
import Backup from './pages/Backup';
import './App.css';

const themeConfig = {
  token: {},
  components: {
    Menu: {
      itemBg: 'transparent',
      itemHoverBg: 'rgba(255, 255, 255, 0.08)',
      itemSelectedBg: 'rgba(255, 255, 255, 0.15)',
      horizontalItemSelectedBg: 'rgba(255, 255, 255, 0.15)',
      subMenuItemBg: 'rgba(30, 50, 100, 0.95)',
    },
  },
};

function App() {
  dayjs.locale('it');

  return (
    <ConfigProvider locale={itIT} theme={themeConfig}>
      <AuthProvider>
        <TenantProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
            <Route path="/companies" element={<ProtectedRoute><Companies /></ProtectedRoute>} />
            <Route path="/workers" element={<ProtectedRoute><Workers /></ProtectedRoute>} />
            <Route path="/vehicles" element={<ProtectedRoute><Vehicles /></ProtectedRoute>} />
            <Route path="/equipments" element={<ProtectedRoute><Equipments /></ProtectedRoute>} />
            <Route path="/chemicals" element={<ProtectedRoute><Chemicals /></ProtectedRoute>} />
            <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute allowedRoles={['admin', 'qhse_nke']}><Settings /></ProtectedRoute>} />
            <Route path="/admin/document-types" element={<ProtectedRoute allowedRoles={['admin', 'qhse_nke']}><DocumentTypes /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute allowedRoles={['admin', 'qhse_nke']}><Users /></ProtectedRoute>} />
            <Route path="/admin/backups" element={<ProtectedRoute allowedRoles={['admin']}><Backup /></ProtectedRoute>} />
            <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Router>
        </TenantProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
